/*
*###############################################################################
*Module Name                   : BarcodePrint.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import BarcodePrintContent from './BarcodePrintContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react'

const BarcodePrint = (props) => {

    let history = useHistory();
    //*** User input related states */
    const [strLocCode, SetLocCode] = useState("")
    const [strLocDesc, SetLocDesc] = useState("")
    const [txnType, SetTxnType] = useState("")
    const [txnTypeList, SetTxnTypeList] = useState([])
    const [strBarCode, SetCode] = useState("");// Set Code
    const [txnprintType, SetTxnPrintType] = useState("")
    const [txnprintEnable, SetTxnPrintEnable] = useState(false)
    const [strLocation, SetLocation] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    const [dataTable, SetDataTable] = useState([])
    const [totalProducts, SetTotalProducts] = useState(0)
    const [totalBarcodes, SetTotalBarcodes] = useState(0)

    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [Modemodal_xlarge, setModemodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(false)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [printEnable, SetPrintEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    const {
        getMenuDetails, addtoFavourite
    } = useContext(Context);
    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var LocationDesc = obj[4]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.strHelpUrl)
                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {

                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {
                                setAutoCode(responseData.data)
                            }
                        } else {
                            setNullCode(true)
                        }
                    })

            }).catch(error =>
                console.log('error', error)
            );

    }, [])

    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        SetLocCode(LocationCode)
        SetLocDesc(LocationName)

        var menuTAG = ""
        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );

        function TxnTypeDropdown() {
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            fetch(`${ApiURL}common/TxnTypeBarCodeDrop`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    SetTxnTypeList(result.data)
                    let dt = result.data

                }).catch(error => console.log('error', error));
        }

        TxnTypeDropdown()

    }, [])


    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };


    function getData(searchData) {

        if (txnType == "") {
            displayAlertMessage('danger', "Please Select Txn Type")
            return;
        }

        if (searchData != "") {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Fetching...")
            var newitemset = []
            fetch(`${ApiURL}BarcodePrint/${txnType}/${searchData}/${strLocCode}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
            }).then(Response => Response.json())
                .then(responseData => {
                    SetLoadingAlert(false)
                    if (responseData.success == true) {

                        SetPrintEnable(true)
                        setShow(false)
                        setDisabled(true)

                        responseData.data.map((item, index) => {
                            newitemset.push({
                                "id": index,
                                "code": item.code,
                                "stockcode": item.stockcode,
                                "name": item.name,
                                "reference": item.reference,
                                "selling": item.selling,
                                "unit": item.unit,
                                "qty": item.qty
                            })
                        })

                        SetDataTable(newitemset)

                    } else if (responseData.success == false) {
                        displayAlertMessage('success', "Record Not Found !")
                        SetDataTable([])
                    }
                })
        } else {
            displayAlertMessage('danger', "Please Enter Document Number !")
        }
    }
    //*** End useEffect */

    // print Function
    async function handlePrint(option) {



        var newUid = uuid()
        const modifiedList = []


        dataTable.forEach((item, index) => {
            modifiedList.push({
                "SerialNo": newUid,
                "ProCode": item.code,
                "StockCode": item.stockcode,
                "Name": item.name,
                "Reference": item.reference,
                "Selling": item.selling.toString(),
                "Unit": item.unit,
                "QTY": parseFloat(item.qty),
            })
        })


        const barcodeTable = {
            "BarcodeDetails": modifiedList,
            "createdBy": LogUserType,
            "location": strLocCode,
            "txnType": txnType,
        }


        const ReportURL = window.Links.ReportURL
        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        //*** save/update records */

        if (option == "PDF") {
            fetch(`${ApiURL}BarcodePrint/print`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                    body: JSON.stringify(barcodeTable)
                }
            ).then(Response => {
                if (Response.status == "200") {
                    SetLoadingAlert(false)
                    Response.json()
                        .then(responseData => {
                            if (responseData.success == true) {
                                displayAlertMessage('success', "Data Saved Successfully !")
                                ClearItem()
                            } else if (responseData.success == false) {
                                displayAlertMessage('danger', "Something Went Wrong !")
                            }
                        })
                } else if (Response.status == "400") {
                    SetLoadingAlert(false)
                    Response.json()
                        .then(responseData => {
                            setErrorMsg(responseData.msg)
                        })
                    setDisabled(false)
                    setDisabledCode(false)
                    displayAlertMessage('danger', "Error !")
                } else {
                    SetLoadingAlert(false)
                    ClearItem()
                }
            }).catch(error => {
                console.log(error.message)
            })
        } else {

            fetch(`${ApiURL}BarcodePrint/printText`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                    body: JSON.stringify(barcodeTable)
                }
            ).then(Response => {
                if (Response.status == "200") {
                    SetLoadingAlert(false)
                    Response.json()
                        .then(responseData => {
                            if (responseData.success == true) {
                                const msg = responseData.msg
                                //window.open(`${ReportURL}temp_print/${msg}.txt`)
                                // 
                                const Link = document.createElement('a');
                                Link.href = `./Barcodes/${msg}.txt`;
                                Link.setAttribute(
                                    'download',
                                    `Barcode.txt`,
                                );

                                // Append To Html Link Element Page
                                document.body.appendChild(Link);

                                // Start Download
                                Link.click();
                                ClearItem()

                            } else if (responseData.success == false) {
                                displayAlertMessage('danger', "Something Went Wrong !")
                            }
                        }
                        )
                } else if (Response.status == "400") {
                    SetLoadingAlert(false)
                    Response.json()
                        .then(responseData => {
                            setErrorMsg(responseData.msg)
                        })
                    setDisabled(false)
                    setDisabledCode(false)
                    displayAlertMessage('danger', "Error !")
                } else {
                    SetLoadingAlert(false)
                    ClearItem()
                }
            }).catch(error => {
                console.log(error.message)
            })

        }
        //***save/update end */
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    function TXNModemodal_xlarge() {

        if (txnType == "") {
            displayAlertMessage('danger', "Please Select Txn Type")
            return;
        }

        setModemodal_xlarge(!Modemodal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function uuid() {

        var uuid = "";
        var i, random;
        for (i = 0; i < 15; i++) {
            random = Math.random() * 16 | 0;
            if (i == 8 || i == 12 || i == 16 || i == 20) {
                uuid += ""
            }
            uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
        }
        return uuid;


    }

    //save button function
    const handlesave = async (type) => {


    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetLocCode(row.LOC_CODE)
        SetLocDesc(row.LOC_DESC)

        setDisabled(false)
        setDisabledCode(false)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    const GetModeSelectedRow = (e, row, isSelect, rowIndex) => {
        // SetModeCode(row.MODE_CODE)
        // SetModeDesc(row.MODE_DESC)
        getData(row.HED_RUNNO)
        SetCode(row.HED_RUNNO)
        setModemodal_xlarge(!Modemodal_xlarge);
    }


    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(false)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(false)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetLocation("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(false)
        setReason("Created")
        SetEditEnable(false)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        SetTxnType("")
        SetCode("")
        SetDataTable([])
        SetTotalBarcodes(0)
        SetTotalProducts(0)
        SetPrintEnable(false)
        setTimeout(() => {
            setExcelItems([])
        }, 1)
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        SetLocCode(LocationCode)
        SetLocDesc(LocationName)
    }

    //********Delete button function */
    const handleDelete = () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strBarCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {

                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)
                        } else {
                            ClearItem()
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }
    //*********Delete button function end */

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setAlertConfirmOption(7)
                                setAlertDescription("Do you wish to print barcode using third party software ?")
                                setsweetAlertShow(true)
                                // setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    function getLocationData(code) {

        if (code != "") {
            var data = [];
            var requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            fetch(`${ApiURL}Locations/SearchCode/${code}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    data = result.data;
                })
                .catch(error => console.log('error', error));
            return data;
        }

    }



    //   Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                window.location.href = "/";
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    // setprintoptionShow(true)

                                                    setAlertConfirmOption(7)
                                                    setAlertDescription("Do you wish to print barcode using third party software ?")
                                                    setsweetAlertShow(true)

                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 7) {
                                                handlePrint("PDF")
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)

                                            if (AlertConfirmOption == 7) {
                                                handlePrint("XCEL")
                                            }

                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={printEnable}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <BarcodePrintContent
                                            GetSelectRow={GetSelectRow}
                                            GetModeSelectedRow={GetModeSelectedRow}
                                            CodeValue={strBarCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    20,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}

                                            DescValue={strLocation}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetLocation(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}

                                            modeModelOpen={Modemodal_xlarge}
                                            modeModelTrigger={TXNModemodal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)

                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            dataTable={dataTable}
                                            SetDataTable={SetDataTable}
                                            strLocCode={strLocCode}
                                            locCodeOnchange={(e) => {
                                                var val1 = Text(e.target, 5, true, false, "upper", false)
                                                SetLocCode(val1)
                                            }}
                                            strLocDesc={strLocDesc}
                                            txnType={txnType}
                                            txnTypeOnChange={(e) => {
                                                SetTxnType(e["value"])
                                            }}
                                            printType={txnprintType}
                                            printEnable={txnprintEnable}
                                            totalProducts={totalProducts}
                                            totalBarcodes={totalBarcodes}
                                            menuCode={menuCode}
                                            locationOnBlur={(e) => {
                                                getLocationData(e.target.value)
                                            }}
                                            txnTypeList={txnTypeList}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default BarcodePrint